module.exports = __webpack_public_path__ + "img/LTS_MOR.45cec9bb.gif";